<template>
  <v-dialog
    v-model="modal"
  >
    <v-card class="annotation-modal">
      {{ issue }}
      <div id="annotations" v-show="issueImg">
        <img :src="issueImg" ref="img" />
        <div v-if="issue && imageToDisplayFactor" class="shapes" >
          <Annotation
            v-for="(ann, ix) in issue.annotations"
            :key="ix"
            :ann="ann"
            :imageToDisplayFactor="imageToDisplayFactor"
            :allAnnotations="issue.annotations"
          />
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import Annotation from './Annotation.vue';

export default {
  name: 'Annotations',
  components: {
    Annotation,
  },
  props: [
    'showAnnotations',
    'issue',
  ],
  computed: {
    modal: {
      get() { return this.showAnnotations; },
      set(val) { if (!val) this.$emit('closeAnnotations'); },
    },
    issueImg() {
      return this.issue.screenshotUrl;
    },
    imageToDisplayFactor() {
      return this.issue.height / this.issue.width;
    },
  },
};
</script>
<style lang="scss" scoped>
#annotations {
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  background-color: green;
}
.shapes {
  position: absolute;
}
img {
  position: absolute;
}
.annotation-modal {
  background-color: white !important;
  height: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/Annotations.vue